import { render, staticRenderFns } from "./LoginPassword.vue?vue&type=template&id=2515913c&scoped=true"
import script from "./LoginPassword.vue?vue&type=script&lang=js"
export * from "./LoginPassword.vue?vue&type=script&lang=js"
import style0 from "./LoginPassword.vue?vue&type=style&index=0&id=2515913c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2515913c",
  null
  
)

export default component.exports